console.log('scripts.js v1.0');


function isResponsiveDevice() {
    
    // media query event handler
    if(matchMedia) {
        const mediaQuery = window.matchMedia('(max-width: 600px)')

        //initialise on page load
        WidthChange(mediaQuery);
        
        //check on change
        mediaQuery.addEventListener("change", () => {

            WidthChange(mediaQuery);
        })
    }

    // media query change
    function WidthChange(mediaQuery) {
        if (mediaQuery.matches) {
            // window width is at least 600px
            mobileNavMenu();
            
        }
    }
}

function mobileNavMenu() {
    
    const mobileNavMenuElement = document.querySelector('.wp-block-navigation__responsive-container');
    const subMenus = document.querySelectorAll(".wp-block-navigation__submenu-container");

    console.log('mobile menu')
    
    for(const subMenu of subMenus ){
        
        const clickToggleElement = subMenu.parentElement.querySelector('a.wp-block-navigation-item__content')
        subMenu.classList.add('js-closed')
        clickToggleElement.classList.add('js-menu-element-closed')

        //Create some top level links
        // const href = clickToggleElement.href
        // const text = clickToggleElement.textContent
        // const aTag = document.createElement('a');
        // if (href) {
            
        //     aTag.classList.add('js-dropdown-link')
        //     aTag.textContent = `Go to ${text} page`
        //     aTag.href = href           
        // }
    
        clickToggleElement.addEventListener('click', (event) => {

            event.preventDefault(); //turns link into dropdown
            subMenu.classList.toggle('js-closed');
            subMenu.classList.toggle('js-open');
            clickToggleElement.classList.toggle('js-menu-element-closed')
            clickToggleElement.classList.toggle('js-menu-element-open')
            
            // subMenu.prepend(aTag)
        } )

        //identify third level menu and add class for styling if different
        const thirdLevelMenu = subMenu.querySelectorAll('.wp-block-navigation__submenu-container')
        if (thirdLevelMenu.length > 0) {

            for (const thirdLevelMenuItem of thirdLevelMenu) {

                console.log(thirdLevelMenuItem);

                thirdLevelMenuItem.classList.add('js-has-third-level-menu')
            }
        }

    }   
}

//There is a fixed button element with the css class js-show-on-mobile-menu that shows when the mobile menu is open
function toggleMobileMenuCTAbutton() { 

    const mobileMenuButton = document.querySelector('.js-show-on-mobile-menu')
    const mobileMenu = document.querySelector('.wp-block-navigation__responsive-container')

    if (!mobileMenuButton || !mobileMenu) return;

    mobileMenuButton.style.display = 'none'; // Hide the button by default

    // Observe changes to the mobile menu's class list
    const observer = new MutationObserver(() => {
        if (mobileMenu.classList.contains('has-modal-open')) { 
            mobileMenuButton.style.display = 'block'; // Show the button when the menu is open 
        }
        else {
            mobileMenuButton.style.display = 'none'; // Hide the button when the menu is closed
        }
    });

    observer.observe(mobileMenu, { attributes: true, attributeFilter: ['class'] });
    
} 


//Sticky column style elements vs Header height 
function calculateHeaderHeightforStickyColumn() {
    
    const header = document.querySelector('header');
    if (!header) return;
    const headerHeight = header.offsetHeight;
    const padding = 100;
    const stickyColumnTopStyle = `${headerHeight + padding}px`;
    const allStickyColumns = document.querySelectorAll('.is-style-sticky-column');

    for (const stickyColumn of allStickyColumns) {
        
        stickyColumn.style.top = stickyColumnTopStyle;
    }
}

function setClassAnchorLinksAutomatically() {

    const allLinksOnPage = document.querySelectorAll('a');

    if(allLinksOnPage.length === 0) return;

    for(const linkOnPage of allLinksOnPage){


        //now workout if there is a # in the href and apply a custom class this is then picked up by smoothAnchorScroll()
        if(linkOnPage.hash){

            //check if this is an offpage anchor link EG https://google.co.uk/#anchor-link
            const isRemoteAnchorLink = linkOnPage.baseURI !== linkOnPage.href.replace(/#.*$/, ''); //<-- removes hash value from href for equivalence test

            if(isRemoteAnchorLink) continue; // do nothing if this is not an onp age anchor link

            linkOnPage.classList.add('anchor-link')

        } else {
            linkOnPage.classList.remove('anchor-link') //just in case # anchor is removed without class being removed by content editor
        }
    }
}

function smoothAnchorScroll() {


    const anchorLinks =  document.querySelectorAll('.anchor-link a, .anchor-link'); //sometimes actual link is nested in button block.

    if(anchorLinks.length === 0) return;

    for(const anchorLink of anchorLinks){

        const anchorToElementID = anchorLink.hash //matches up the anchor with the element ID to scroll to EG: #anchor-section

        if(anchorToElementID !== undefined){

            anchorLink.addEventListener("click", (event) => {
                event.preventDefault();
                document.querySelector(anchorToElementID).scrollIntoView({ behavior: 'smooth' });
            })
        }
    }
}

function downloadCSVfiles() {
    
    //If link is CSV then add download attribute

    const allLinks = document.querySelectorAll('a');

    for (const link of allLinks) {
        
        if (link.href.includes('.csv')) {

            const filenameCSV = link.href.substring(link.href.lastIndexOf('/')).replace('/','') //looks for the last word after last '/' then strips '/'

            link.setAttribute('download', filenameCSV);
        }
    }
}

function navBarScrollHide() {

    let lastScrollTop = 0;
    const navbars = document.querySelectorAll('.js-on-scroll-hide-nav');

    if (!navbars.length) return;

    const scrollHandler = () => {

        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

        //cycle through all navbars with the class js-on-scroll-hide-nav and apply the scroll hide show logic
        for (const nav of navbars) {
            if (scrollTop > lastScrollTop) {
                // Scrolling down
                nav.classList.add('nav-hidden');
                nav.classList.remove('nav-visible');
            } else {
                // Scrolling up
                nav.classList.remove('nav-hidden');
                nav.classList.add('nav-visible');

            }
        }

        lastScrollTop = scrollTop <= 0 ? 0 : scrollTop; // For Mobile or negative scrolling 
           
    }
        
    //debounce the scroll event listener to improve performance by limiting how often the function runs during scrolling
    const debounce = (func, wait) => {

        let timeout;
        return function(...args) {
            clearTimeout(timeout);
            timeout = setTimeout(() => func.apply(this, args), wait);
        };

    };

    window.addEventListener('scroll', debounce(scrollHandler, 50)); // Adjust the debounce delay as needed (e.g., 100ms)

}

function sectionOverlapFooter() {

    console.log('sectionOverlapFooter')
    
    const sectionOverlapFooter = document.querySelector('.is-style-section-footer-overlap') //added via block style
    const footer = document.querySelector('.footer-content') //place this inside the footer group.

    if (!sectionOverlapFooter || !footer) return;

    const additionalPadding = 100; //add some additional padding to stop content being too close to the edge of the footer
    const computedHeight = (sectionOverlapFooter.offsetHeight / 2); //we want to pull the footer up by half the height of the section that is overlapping
    const footerCurrentMarginTop = parseInt(window.getComputedStyle(footer.parentElement).marginBlockStart) || 0;
    const placementOffsetCentre = computedHeight + footerCurrentMarginTop; 
    footer.style.paddingTop = `${computedHeight + additionalPadding}px`; //add padding to the top of the footer so that content is not overlapped by the section
    sectionOverlapFooter.style.marginBottom = `-${placementOffsetCentre}px`; //pull the section up by the calculated amount to overlap the footer
}

function responsiveVideoIframe(){

    const videoIframes = document.querySelectorAll('iframe[title="vimeo-player"], iframe[title="YouTube video player"], .mobile-video-responsive iframe');

    for(let videoIframe of videoIframes){

        videoIframe.parentElement.classList.add('video-iframe-responsive');

    }
}

document.addEventListener("DOMContentLoaded", function() {

    isResponsiveDevice()
    responsiveVideoIframe()
    setClassAnchorLinksAutomatically()
    smoothAnchorScroll()
    calculateHeaderHeightforStickyColumn()
    downloadCSVfiles()
    toggleMobileMenuCTAbutton()
    navBarScrollHide()
    sectionOverlapFooter()
});